// TODO(Sergio): Temporary skip eslint rules, this is part of the A6-A12 migration from mono-frontend

/* eslint-disable @typescript-eslint/no-explicit-any, complexity, @typescript-eslint/ban-ts-comment, @angular-eslint/no-output-native, max-lines */
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {
  DateSelectEntity,
  DayEntity
} from './models/calendar-single.interfaces';
import { DateCommonService } from './service/date-common.service';
import { DateService } from './service/date.service';

@Component({
  selector: 'idp-calendar-single',
  templateUrl: './calendar-single.component.html',
  styleUrls: ['./calendar-single.component.scss']
})
export class CalendarSingleComponent implements OnInit, AfterViewInit {
  @Input() bottomLabelText = '';
  @Input() topLabelText = '';
  @Input() labelTxt = 'Demo Label';
  @Input() mode: 'single' | 'double' = 'single';
  @Input() id = '';
  @Input() monthLabel = '';
  @Input() yearLabel = '';
  @Input() selectedDate = `${
    new Date().getMonth() + 1
  }/${new Date().getDate()}/${new Date().getFullYear()}`;

  calendarModel: (DayEntity | null)[][] | undefined;
  @Input() showFooter = true;
  @Input() showCloseButton = true;
  @Input() inDropdown = false;
  @Input() disableFuture = false;
  @Input() disablePrevious = false;
  @Input() errorMessage: any;
  @Input() errorState: any;
  @Input() numbrOfPrevDays = 0;
  @Input() numbrOfFutureDays = 0;
  @Input() hideClearButton = false;
  @Input() hideDoneButton = false;
  @Output() value: EventEmitter<{
    id: string;
    value: string;
  }> = new EventEmitter<{ id: string; value: string }>();

  @Output() hasFocus: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() open: EventEmitter<boolean> = new EventEmitter<boolean>();
  selectedScreenReaderText = '';
  focusedDate = `${
    new Date().getMonth() + 1
  }/${new Date().getDate()}/${new Date().getFullYear()}`;

  currentDate = `${
    new Date().getMonth() + 1
  }/${new Date().getDate()}/${new Date().getFullYear()}`;

  hideLeftArrow = false;
  hideRightArrow = false;
  renderedDate: Date | undefined;
  @Input() monthOffsetValue = 0;
  maxDate: Date;
  minimumDate: Date;
  private yearOffsetValue = 0;
  private monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  private firstDayFocus = true;

  constructor(
    public elementRef: ElementRef,
    public changeDetectorRef: ChangeDetectorRef,
    private dateService: DateService,
    private dateCommonService: DateCommonService
  ) {
    this.maxDate = new Date(this.currentDate);
    this.minimumDate = new Date(this.currentDate);
  }

  _openCalendarFlag = false;

  @Input() set openCalendarFlag(value: boolean) {
    if (this._openCalendarFlag !== value) {
      this._openCalendarFlag = value;

      if (this.isMaxMonth() || this.isMinMonth()) {
        this.toggleArrows();
      } else if (this.monthOffsetValue === 0) {
        this.hideRightArrow = false;
        this.hideLeftArrow = false;
      }
      this.renderCalendarModel();
    }
  }

  _anchorDate = `${
    new Date().getMonth() + 1
  }/${new Date().getDate()}/${new Date().getFullYear()}`;

  @Input() set anchorDate(value: string) {
    if (value !== this._anchorDate) {
      if (value) {
        this._anchorDate = value;
        this.focusedDate = value;
        this.selectedDate = value;
      } else {
        this._anchorDate = `${
          new Date().getMonth() + 1
        }/${new Date().getDate()}/${new Date().getFullYear()}`;
        this.focusedDate = `${
          new Date().getMonth() + 1
        }/${new Date().getDate()}/${new Date().getFullYear()}`;
        this.selectedDate = `${
          new Date().getMonth() + 1
        }/${new Date().getDate()}/${new Date().getFullYear()}`;
      }
      this.renderCalendarModel();
    }
  }

  ngOnInit() {
    this.setMaxMinDates();
    this.renderedDate = new Date();
    this.renderCalendarModel();
  }

  ngAfterViewInit() {
    this.hasFocus.emit(true);

    if (
      this.elementRef.nativeElement.querySelector(
        '.calendar-table__anchor-date'
      )
    ) {
      this.elementRef.nativeElement
        .querySelector('.calendar-table__anchor-date')
        .focus();
    }

    this.changeDetectorRef.detectChanges();
  }

  setMaxMinDates() {
    this.maxDate = new Date(this.currentDate);
    if (this.numbrOfFutureDays && this.numbrOfFutureDays > 0) {
      this.maxDate.setDate(this.maxDate.getDate() + this.numbrOfFutureDays);
    } else {
      this.maxDate.setDate(this.maxDate.getDate() + 331);
    }
    this.minimumDate = new Date(this.currentDate);
    if (this.numbrOfPrevDays && this.numbrOfPrevDays > 0) {
      this.minimumDate.setDate(
        this.minimumDate.getDate() - this.numbrOfPrevDays
      );
    } else if (this.disablePrevious && this.numbrOfPrevDays === 0) {
      this.minimumDate = new Date(this.currentDate);
    } else {
      this.minimumDate.setFullYear(this.minimumDate.getFullYear() - 2);
    }
  }

  incrementMonthOffset(event: any) {
    const td = new Date(this.currentDate);
    if (this.numbrOfFutureDays && this.numbrOfFutureDays > 0) {
      td.setDate(td.getDate() + this.numbrOfFutureDays);
    } else {
      td.setDate(td.getDate() + 331);
    }

    if (
      this.monthNames[td.getMonth()] === this.monthLabel &&
      parseInt(this.yearLabel, 10) >= td.getFullYear()
    ) {
      this.toggleArrows();
      return;
    }

    if (
      (this.disableFuture && this.isOriginalDateDisplayed()) ||
      this.hideRightArrow
    ) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (event.target.tagName === 'I') {
      event.target.parentElement.focus();
    }

    this.checkFocus();
    this.monthOffsetValue += 1;
    this.renderCalendarModel();

    this.toggleArrows();
    this.setRenderedDate();
  }

  decrementMonthOffset(event: any) {
    const td = new Date(this.currentDate);
    if (this.numbrOfPrevDays && this.numbrOfPrevDays > 0) {
      td.setDate(td.getDate() - this.numbrOfPrevDays);
    } else {
      td.setMonth(td.getMonth() - 24);
    }

    if (
      this.monthNames[td.getMonth()] === this.monthLabel &&
      parseInt(this.yearLabel, 10) === td.getFullYear()
    ) {
      this.toggleArrows();
      return;
    }

    if (
      (this.disablePrevious && this.isOriginalDateDisplayed()) ||
      this.hideLeftArrow
    ) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (event.target.tagName === 'I') {
      event.target.parentElement.focus();
    }

    this.checkFocus();

    this.monthOffsetValue -= 1;
    this.renderCalendarModel();
    this.checkFocus();

    this.setRenderedDate();
    this.toggleArrows();
  }

  renderCalendarModel() {
    this.monthLabel = this.dateService.getFormattedMonth(
      this.monthOffsetValue,
      this.yearOffsetValue,
      this._anchorDate
    );
    this.yearLabel = this.dateService.getFormattedYear(
      this.monthOffsetValue,
      this.yearOffsetValue,
      this._anchorDate
    );
    this.calendarModel = this.dateService.getCalendar(
      this.monthOffsetValue,
      this.yearOffsetValue,
      this._anchorDate
    );
  }

  setRenderedDate() {
    this.renderedDate = new Date(
      new Date().setMonth(
        new Date().getMonth() +
          this.monthOffsetValue +
          new Date(this._anchorDate).getMonth() -
          new Date(this.currentDate).getMonth()
      )
    );
    this.renderedDate.setFullYear(parseInt(this.yearLabel, 10));
  }

  isMinMonth() {
    return (
      // @ts-ignore
      this.renderedDate.getFullYear() < this.minimumDate.getFullYear() ||
      // @ts-ignore
      (this.renderedDate.getFullYear() === this.minimumDate.getFullYear() &&
        // @ts-ignore
        this.renderedDate.getMonth() <= this.minimumDate.getMonth())
    );
  }

  isMaxMonth() {
    return (
      // @ts-ignore
      this.renderedDate.getFullYear() > this.maxDate.getFullYear() ||
      // @ts-ignore
      (this.renderedDate.getFullYear() === this.maxDate.getFullYear() &&
        // @ts-ignore
        this.renderedDate.getMonth() >= this.maxDate.getMonth())
    );
  }

  toggleArrows() {
    if (this.isMaxMonth()) {
      this.hideLeftArrow = false;
      this.hideRightArrow = true;
    } else if (this.isMinMonth()) {
      this.hideLeftArrow = true;
      this.hideRightArrow = false;
    } else {
      this.hideRightArrow = false;
      this.hideLeftArrow = false;
    }
  }

  disableDayClick(value: any) {
    const selectedDayDate = new Date(value.value);

    if (
      this.maxDate.getMonth() === selectedDayDate.getMonth() &&
      this.maxDate.getFullYear() === selectedDayDate.getFullYear() &&
      this.maxDate.getDate() < selectedDayDate.getDate()
    ) {
      return true;
    }

    return (
      this.minimumDate.getMonth() === selectedDayDate.getMonth() &&
      this.minimumDate.getFullYear() === selectedDayDate.getFullYear() &&
      this.minimumDate.getDate() > selectedDayDate.getDate()
    );
  }

  disableSelectPrevious(value: any, type: any) {
    return (
      (this.disablePrevious && type === 'previous') ||
      this.isMoreOrLessThanAllowed(value) ||
      type === 'next' ||
      (this.disablePrevious &&
        this.isPrevious(value) &&
        this.isOriginalDateDisplayed())
    );
  }

  disableSelectFuture(value: any, type: any) {
    return (
      (this.disableFuture && type === 'previous') ||
      this.isMoreOrLessThanAllowed(value) ||
      type === 'next' ||
      (this.disableFuture &&
        this.isFuture(value) &&
        this.isOriginalDateDisplayed())
    );
  }

  selectValue(event: Event, value: any, type: any) {
    const valueArray = value.value.split('/');
    const td = new Date(this._anchorDate);

    if (this.disableDayClick(value)) {
      return;
    }

    if (this.disableSelectPrevious(value, type)) {
      return;
    }
    if (this.disableSelectFuture(value, type)) {
      return;
    }

    td.setMonth(td.getMonth() - 24);
    if (
      this.monthNames[td.getMonth()] === this.monthLabel &&
      td.getDate() > parseInt(valueArray[1], 10) &&
      parseInt(this.yearLabel, 10) === td.getFullYear()
    ) {
      return;
    }

    if (type === 'current') {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      this.selectedScreenReaderText = `Date selected as ${valueArray[1]} ${this.monthLabel} ${valueArray[2]}`;
      this.elementRef.nativeElement
        .querySelector('.calendar-container__sr-only')
        .focus();
      setTimeout(() => {
        this.selectedScreenReaderText = '';
      }, 1000);
      this.value.emit(value);
      this.checkFocus();
      if (this.hideDoneButton) {
        this.open.emit(false);
      }
    }
  }

  /**
   *  To check whether the date is disabed
   */
  hasInactiveClass(day: DayEntity | null) {
    if (!day) {
      day = {} as DayEntity;
    }
    return (
      day.type === 'previous' ||
      this.isMoreOrLessThanAllowed(day) ||
      day.type === 'next' ||
      (this.disablePrevious &&
        this.isPrevious(day) &&
        this.isOriginalDateDisplayed()) ||
      (this.disableFuture &&
        this.isFuture(day) &&
        this.isOriginalDateDisplayed())
    );
  }

  // @ts-ignore
  /**
   *  To select the date and focus the selected date in calendar widget
   */
  selectValueAndFocus(event: Event, value: DateSelectEntity, type: string) {
    const ev = event ? (event.currentTarget as HTMLElement) : '';
    if (ev && !ev.classList.contains('calendar-table__inactive')) {
      this.selectValue(event, value, type);
      this.dateCommonService.focusOnSelectedDate(value, this.elementRef);
      this.focusedDate = value.value;
    }
  }

  checkFocus() {
    this.hasFocus.emit(this.isFocused());
  }

  isFocused(): boolean {
    return true;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  clear(event: any) {
    // @ts-ignore
    this.value.emit(null);
  }

  close(event: any) {
    event.stopPropagation();
    event.preventDefault();

    this.open.emit(false);
  }

  /**
   *  To add screenreader text to the next focused date if selected
   */
  newUpdatedDate(date: number) {
    const newPost = this.elementRef.nativeElement.querySelector(
      '.calendar-table-day__current--' + date
    );
    if (newPost && newPost.classList.contains('calendar-table__event')) {
      this.selectedScreenReaderText = 'Date selected as';
      setTimeout(() => {
        this.selectedScreenReaderText = '';
      }, 1000);
    }
  }

  getDateStringFromElement(event: any): string {
    if (
      event &&
      event.target &&
      event.target.getAttribute('data-calendar-date')
    ) {
      return event.target.getAttribute('data-calendar-date');
    }

    return '';
  }

  focusNext(direction: string, event: any) {
    event.preventDefault();
    event.stopPropagation();

    let nextDate = this.getDateStringFromElement(event);
    let nextDateObject: Date;

    if (!nextDate) {
      nextDate = this.focusedDate;
    }

    if (nextDate) {
      const nextDateArray = nextDate.split('/');
      nextDateObject = new Date(
        parseInt(nextDateArray[2], 10),
        parseInt(nextDateArray[0], 10) - 1,
        parseInt(nextDateArray[1], 10)
      );
    }

    let days;

    this.toggleArrows();

    if (direction === 'left') {
      days = -1;
    }

    if (direction === 'right') {
      days = 1;
    }

    if (direction === 'up') {
      days = -7;
    }

    if (direction === 'down') {
      days = 7;
    }

    // @ts-ignore
    if (nextDateObject) {
      // @ts-ignore
      nextDateObject.setDate(days + nextDateObject.getDate());
      if (this.isMaxDay(nextDateObject) || this.isMinDay(nextDateObject)) {
        return;
      }
    }

    // @ts-ignore
    this.adjustFocusedDate(days);
  }

  isMaxDay(date: Date) {
    return (
      date.getFullYear() > this.maxDate.getFullYear() ||
      (date.getFullYear() === this.maxDate.getFullYear() &&
        date.getMonth() >= this.maxDate.getMonth() &&
        date.getDate() > this.maxDate.getDate()) ||
      (date.getFullYear() === this.maxDate.getFullYear() &&
        date.getMonth() > this.maxDate.getMonth())
    );
  }

  isMinDay(date: Date) {
    return (
      date.getFullYear() < this.minimumDate.getFullYear() ||
      (date.getFullYear() === this.minimumDate.getFullYear() &&
        date.getMonth() <= this.minimumDate.getMonth() &&
        date.getDate() < this.minimumDate.getDate()) ||
      (date.getFullYear() === this.minimumDate.getFullYear() &&
        date.getMonth() < this.minimumDate.getMonth())
    );
  }

  adjustFocusedDate(days: number) {
    const focusedDateArray = this.focusedDate
      .split('/')
      .map((value) => parseInt(value, 10));

    const recursiveFocusedDate = new Date(
      // @ts-ignore
      this.renderedDate.getFullYear(),
      // @ts-ignore
      this.renderedDate.getMonth(),
      focusedDateArray[1]
    );
    const newFocusedDate = new Date(recursiveFocusedDate);
    const todayDatePlusOffset = new Date(this._anchorDate);

    todayDatePlusOffset.setMonth(
      todayDatePlusOffset.getMonth() + this.monthOffsetValue
    );
    newFocusedDate.setDate(recursiveFocusedDate.getDate() + days);
    this.newUpdatedDate(newFocusedDate.getDate());
    if (
      this.isMinMonth() &&
      todayDatePlusOffset.getMonth() !== recursiveFocusedDate.getMonth()
    ) {
      let dayCount = 1;
      this.focusedDate = `${
        todayDatePlusOffset.getMonth() + 1
      }/${dayCount}/${todayDatePlusOffset.getFullYear()}`;

      if (this.isMinDay(new Date(this.focusedDate))) {
        while (this.isMinDay(new Date(this.focusedDate))) {
          dayCount += 1;
          this.focusedDate = `${
            todayDatePlusOffset.getMonth() + 1
          }/${dayCount}/${todayDatePlusOffset.getFullYear()}`;
        }
      }

      setTimeout(() => {
        if (
          this.elementRef.nativeElement.querySelector(
            `.calendar-table-day__current--${dayCount}`
          )
        ) {
          this.elementRef.nativeElement
            .querySelector(`.calendar-table-day__current--${dayCount}`)
            .focus();
        }
      });
    } else {
      this.focusedDate = `${
        newFocusedDate.getMonth() + 1
      }/${newFocusedDate.getDate()}/${newFocusedDate.getFullYear()}`;
      setTimeout(() => {
        this.elementRef.nativeElement
          .querySelector(
            '.calendar-table-day__current--' + newFocusedDate.getDate()
          )
          .focus();
      });

      if (
        newFocusedDate.getDate() <= 7 &&
        recursiveFocusedDate.getDate() >= 21
      ) {
        this.monthOffsetValue += 1;
        this.renderCalendarModel();
        this.renderedDate = new Date(
          new Date().setMonth(new Date().getMonth() + this.monthOffsetValue)
        );
      } else if (
        newFocusedDate.getDate() >= 21 &&
        recursiveFocusedDate.getDate() <= 7
      ) {
        this.monthOffsetValue -= 1;
        this.renderCalendarModel();
        this.renderedDate = new Date(
          new Date().setMonth(new Date().getMonth() + this.monthOffsetValue)
        );
      }
    }
  }

  goToNextElement(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.elementRef.nativeElement
      .querySelector('.calendar--arrows-btn-right')
      .focus();
  }

  tabNext(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.setTabFocus(
      event,
      '.calendar--arrows-btn-right',
      '.calendar__footer-btn-done'
    );
    this.setTabFocus(
      event,
      '.calendar__footer-btn-done',
      '.calendar__footer-btn-clear'
    );
    this.setTabFocus(
      event,
      '.calendar__footer-btn-clear',
      '.calendar--arrows-btn-left'
    );
    this.setTabFocus(
      event,
      '.calendar--arrows-btn-left',
      '.calendar--arrows-btn-right'
    );
  }

  tabPrevious(event: any) {
    event.preventDefault();
    event.stopPropagation();
    if (event && event.target) {
      this.eventFocus(event);
    }
  }

  isOriginalDateDisplayed() {
    return this.monthOffsetValue === 0 && this.yearOffsetValue === 0;
  }

  isPrevious(testDay: any) {
    const todayArray = this._anchorDate.split('/');
    const testDayArray = testDay.value.split('/');

    return parseInt(testDayArray[1], 10) < parseInt(todayArray[1], 10);
  }

  isFuture(testDay: any) {
    const todayArray = this._anchorDate.split('/');
    const testDayArray = testDay.value.split('/');

    return parseInt(testDayArray[1], 10) > parseInt(todayArray[1], 10);
  }

  eventFocus(event: any) {
    this.setTabFocus(
      event,
      '.calendar--arrows-btn-left',
      '.calendar__footer-btn-clear'
    );
    this.setTabFocus(
      event,
      '.calendar__footer-btn-clear',
      '.calendar__footer-btn-done'
    );
    this.setTabFocus(
      event,
      '.calendar__footer-btn-done',
      '.calendar--arrows-btn-right'
    );
    this.setTabFocus(
      event,
      '.calendar--arrows-btn-right',
      '.calendar--arrows-btn-left'
    );
  }

  isMoreOrLessThanAllowed(day: any) {
    const evaluatedDate = new Date(day.value);

    if (
      this.maxDate.getDate() < evaluatedDate.getDate() &&
      this.maxDate.getMonth() <= evaluatedDate.getMonth() &&
      this.maxDate.getFullYear() <= evaluatedDate.getFullYear()
    ) {
      return true;
    }

    return (
      this.minimumDate.getDate() > evaluatedDate.getDate() &&
      this.minimumDate.getMonth() >= evaluatedDate.getMonth() &&
      this.minimumDate.getFullYear() >= evaluatedDate.getFullYear()
    );
  }

  setTabFocus(event: any, source: any, target: any) {
    if (event && event.target && event.target.matches(source)) {
      this.elementRef.nativeElement.querySelector(target).focus();
    }
  }

  focus(event: Event) {
    // @ts-ignore
    event.target.parentElement.focus();
  }
}
